import {CgEditUnmask} from "react-icons/cg";
import Animate from "./Animate";

const SubTitle = (props) => {

  return (
      <div className='overflow-hidden pb-1'>
        <Animate direction='up' duration={0.6} delay={0.1} distance={50} scrollTriggerStart='bottom bottom'>
          <h4
              className={'font-medium text-xl flex items-center ' + props.addClass}>
            {/*<BsDashLg className={'mr-2 text-amber-500'}/>*/}
            <CgEditUnmask className={'mr-2 text-amber-500'}/>
            {/*<HiViewGrid className={'mr-2 text-amber-500'}/>*/}
            {props.title}
          </h4>
        </Animate>
      </div>
  )
}

export default SubTitle
